import React, { FC } from 'react'
import { useTransition, animated, config } from 'react-spring'
import { useStoreState } from '@mortgage-pos/ui/store'
import useMediaQuery from '@shared-fe/hooks/useMediaQuery'

const PageTransition: FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const { active } = useStoreState((state) => state.questionnaire)

  const desktopTransitions = useTransition(active.name, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    config: config.molasses,
  })

  const mobileTransitions = useTransition(active.name, {
    initial: { opacity: 1 },
    from: { opacity: 1, transform: 'translateX(100vw)' },
    enter: { opacity: 1, transform: 'translateX(0)' },
  })

  const isDesktop = useMediaQuery('(min-width: 950px)', true, false)
  const transitions = isDesktop ? desktopTransitions : mobileTransitions

  return (
    <React.Fragment>
      {transitions((props, item, t, i) => {
        return <animated.div style={{ ...props }}> {children}</animated.div>
      })}
    </React.Fragment>
  )
}

export default PageTransition
